import logo from './logo.svg';
import './App.css';
import Nav from './Component/Nav';
 

function App() {
  return (
    <div className="App">
      <div className='sc-elAWhN jmswUm'>
      <Nav/>
      </div>
     
    </div>
  );
}

export default App;
